import { H3, H5 } from '@components/Typography';
import styled from 'styled-components';

export const SectionRoot = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;

  background-color: ${({ theme }) => theme.color.white};
  font-family: proxima-nova, sans-serif;

  padding: 10rem 12rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 6rem 1.5rem;
  }
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
  align-items: stretch;

  & > * {
    flex: 1 1 calc(25% - 2rem);
    max-width: calc(25% - 2rem);
    display: flex;
  }

  &:has(:only-child),
  &:has(:nth-child(2):last-child),
  &:has(:nth-child(3):last-child) {
    justify-content: center;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    & > * {
      flex: 1 1 calc(50% - 2rem);
      max-width: calc(50% - 2rem);
    }
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    flex-direction: column;
    gap: 4rem;

    & > * {
      flex: 1 1 100%;
      max-width: 100%;
    }
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  background-color: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition:
    transform 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;

  max-width: 254px;
  width: 100%;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.1);
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    width: 100%;
    max-width: 100%;
  }
`;

export const TextWrapper = styled.div`
  padding: 4rem 3rem 3rem 3rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    width: 100%;
  }
`;

export const Title = styled(H3)<{ $color?: string }>`
  color: ${({ theme, $color }) => $color ?? theme.color.mobilityBlue};
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size30};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  text-align: left;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size28};
    line-height: ${({ theme }) => theme.lineHeight.height115};
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size24};
  }
`;

export const Subtitle = styled(H5)<{ $color?: string }>`
  color: ${({ theme, $color }) => $color ?? theme.color.mobilityGrey};
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size18};
  line-height: ${({ theme }) => theme.lineHeight.height165};

  margin-top: 2rem;
  text-align: left;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    text-align: left;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size18};
    font-weight: ${({ theme }) => theme.fontWeight.weight500};
    line-height: ${({ theme }) => theme.lineHeight.height140};
    margin-bottom: 2rem;
    text-align: left;
  }
`;

export const Image = styled.img`
  width: 254px;
  height: 254px;
  aspect-ratio: 1 / 1;
  object-fit: cover;

  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 5rem;
`;
